import * as React from "react";
// import { useOrganizerContext } from "@/contexts/OrganizerContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import NavigationLink from "next/link";
import { Icons } from "../Icons";
import { useAuth } from "@/stores/auth.store";

export default function UserAccountNav({ className }: { className?: string }) {
  // const { user, signOut } = useOrganizerContext();
  const { user, signOut } = useAuth()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);


  return (
    <section className={className + ` cursor-pointer`}>
      <DropdownMenu>
        <DropdownMenuTrigger className="flex text-center items-center ring-none border-none focus:ring-none focus:border-none focus:outline-none static h-full px-2 cursor-pointer">
          <div className="flex items-center justify-between text-center bg-pink-50 rounded-lg p-0.5 pr-2 rounded-l-full rounded-r-full min-w-40">
            <p className="flex text-nowrap bg-red-800 rounded-full !text-[8px] text-white font-light h-7 w-7 p-1 text-center items-center justify-center pointer-events-none">
              {user?.firstName?.charAt(0) +
                "" +
                user?.lastName?.charAt(0)}
            </p>

            <p className="text-nowrap font-light text-xs">
              {user?.firstName} {user?.lastName?.charAt(0)}
            </p>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="bg-background px-1 text-primary border ring-0 focus:ring-0 focus:border"
          align="end"
        >
          <div className="flex items-center justify-start gap-2 p-1">
            <div className="flex items-center text-center gap-0.5 ">
              <p className="text-nowrap bg-red-800 rounded-full text-xs text-white font-light h-6 w-6 p-1 text-center pointer-events-none">
                {user?.firstName?.charAt(0) +
                  "" +
                  user?.lastName?.charAt(0)}
              </p>
            </div>

            <div className="flex flex-col space-y-1 leading-none p-1 pointer-events-none">
              {user && (
                <p className="font-medium truncate">
                  {user?.firstName} {user?.lastName}{" "}
                </p>
              )}
              {user ? (
                <p className="w-[180px] truncate text-sm font-light">
                  {user?.email}
                </p>
              ) : null}
            </div>
          </div>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild className="pb-2 cursor-pointer">
            <NavigationLink href="/user/project" className="flex gap-2">
              p
            </NavigationLink>
          </DropdownMenuItem>

          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer py-2 text-secondary font-semibold flex gap-2 bg-[#FFE2E2] rounded-none"
            onSelect={(event) => {
              event.preventDefault();
              signOut();
            }}
          >
            <Icons.LogOut
              width={18}
              height={18}
              color="#3E3E3E"
              className="font-semibold text-secondary"
            />{" "}
            ออกจากระบบ
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </section>
  );
}
